import React, {createContext, useReducer} from "react";
import {PlayerReducer} from "../reducer/PlayerReducer";
import {BagColor, ContainerType, HelpTypes} from "../PlayerConstant";
import ProgramType from "../../models/enums/program-type";

export const PlayerContext = createContext();

const PlayerContextProvider = (props) => {
    const initState = {
        isInitialized: false,
        pickMorePicklist: false,
        helpType: HelpTypes.DEFAULT,
        scope: ProgramType.AMZL,
        bagColor: BagColor.GRAY,
        item: ContainerType.BAG,
        isBackSelect: false
    };

    const [statePlayer, dispatchPlayer] = useReducer(PlayerReducer, initState);

    return (
            <PlayerContext.Provider value={{statePlayer, dispatchPlayer}}>
                {props.children}
            </PlayerContext.Provider>
    )
}

export default PlayerContextProvider;